import { createAction } from '@reduxjs/toolkit';

import { type VideoState } from '../index';

export const updateVideo = createAction<Partial<VideoState>>('video/update');
